module.exports = __webpack_public_path__ + "static/media/bar-horiz-icon.02dd7e7a.svg";